module.exports = __webpack_public_path__ + "static/media/QS.6cbc8210.svg";